import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "buttonUse", "option", "multi"],
  _excluded2 = ["ref"];
import styled from 'styled-components';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { ColorSwatch } from 'foundations-components/transitional/components/ColorSwatch';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledButtonWrapper = styled.span.withConfig({
  displayName: "CampaignSelectItemComponent__StyledButtonWrapper",
  componentId: "lsx9ah-0"
})(({
  theme
}) => `
  button[aria-disabled='true'] {
    color: ${theme.color['text-core-disabled']} !important;
  }
`);
export default function CampaignSelectItemComponent(_ref) {
  let {
      children,
      buttonUse,
      option,
      multi
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const restProps = _objectWithoutPropertiesLoose(rest, _excluded2);
  if (option.buttonText && option.dropdownText || option.options ||
  // isSpecial cases are for built in functionality like the load more / loading rows.
  option.isSpecial) {
    // If the option is a built in one, we simply return the children wrapped in a span
    return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
      children: children
    }));
  }
  const truncateOptionValue = !option.isInTree && buttonUse === 'transparent' ? {
    maxWidth: 200
  } : undefined;
  const shouldTruncate = option.isInTree || !multi;
  const optionContent = /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    children: [(option.isInTree || option.colorHex) && /*#__PURE__*/_jsx(TFlex, {
      borderRadius: "full",
      marginInlineEnd: "200",
      children: /*#__PURE__*/_jsx(ColorSwatch, {
        "data-test-property-name": `campaign-color-dot-${option.value}`,
        color: option.colorHex,
        size: 4
      })
    }), shouldTruncate ? /*#__PURE__*/_jsx(TruncateString, Object.assign({
      "data-test-id": 'campaign-truncate'
    }, truncateOptionValue, {
      textAlign: "left",
      children: option.text || option.value
    })) : option.text || option.value]
  });
  if (!option.isInTree) {
    return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
      children: optionContent
    }));
  }
  return /*#__PURE__*/_jsx(StyledButtonWrapper, Object.assign({}, restProps, {
    children: /*#__PURE__*/_jsx(Button, {
      padding: "0 !important",
      title: option.text,
      use: "unstyled",
      disabled: option.disabled,
      children: optionContent
    })
  }));
}